import { BASE_PATH, ROUTE_NAMES, ROUTE_PATHS } from "./router.constants";

export const routerMixin = {
  data: function() {
    return {
      BASE_PATH: BASE_PATH,
      ROUTE_NAMES: ROUTE_NAMES,
      ROUTE_PATHS: ROUTE_PATHS,
    };
  },
};
